import Vue from "vue";
import VueRouter from "vue-router";

const Landing = () => import("../views/Landing");
const Survey = () => import("../views/Survey");
const RiskAssessmentResult = () => import("../views/RiskAssessmentResult");

const AssessmentMenu = () => import("../views/AssessmentMenu");
const AssessmentWhoqolBref = () => import("../views/AssessmentWhoqolBref");
const AssessmentHPLP = () => import("../views/AssessmentHPLP");
const AssessmentHPLPResult = () => import("../views/AssessmentHPLPResult");

const AdminDashboard = () => import("../views/AdminDashboard");
const AdminSmsSender = () => import("../views/AdminSmsSender");
const HPLPDashboardCategory = () =>
  import("../components/HPLPDashboardCategory");
const HPLPDashboardGroup = () => import("../components/HPLPDashboardGroup");
const HPLPDashboardOverview = () =>
  import("../components/HPLPDashboardOverview");
const HPLPDashboardFaculty = () => import("../components/HPLPDashboardFaculty");

const WhoqolDashboardCategory = () =>
  import("@/components/WhoqolDashboardCategory");
const WhoqolDashboardGroup = () => import("../components/WhoqolDashboardGroup");
const WhoqolDashboardOverview = () =>
  import("../components/WhoqolDashboardOverview");
const WhoqolDashboardFaculty = () =>
  import("../components/WhoqolDashboardFaculty");


const RiskTopicDashboard = () => import("../components/RiskTopicDashboard");
const RiskDashboard = () => import("../components/RiskDashboard");
const RiskDashboardOverview = () =>
  import("../components/RiskDashboardOverview");
const RiskDashboardFaculty = () => import("../components/RiskDashboardFaculty");
const RiskDashboardEmployee = () =>
  import("../components/RiskDashboardEmployee");

const UserRegister = () => import("../views/UserRegister");
const UserLayout = () => import("../views/UserLayout");
const UserDashboard = () => import("../views/UserDashboard");

const UserRiskDashboard = () => import("../views/UserRiskDashboard");
import UserHPLPDashboard from "../views/UserHPLPDashboard";
import UserWhoQolDashboard from "../views/UserWhoQolDashboard";
import UserOverviewDashboard from "../views/UserOverviewDashboard";
import WhoqolAssessmentResult from "../views/WhoqolAssessmentResult";

import CmuItAccountCallback from "../views/CmuItAccountCallback";
import ManualAssessment from "../views/ManualAssessment";
import ManualReport from "../views/ManualReport";

import FacultyAdminManagement from "../views/FacultyAdminManagement";
import AdminManagement from "../views/AdminManagement";

import AdminAssessmentCompare from "../views/AdminAssessmentCompare";

import HealthRecommendationIndex from "../views/health-recommendation/HealthRecomenndationIndex";
import HealthRecommendationCreate from "../views/health-recommendation/HealthRecommendationCreate";
import HealthRecommendationView from "../views/health-recommendation/HealthRecommendationView";
import HealthRecommendationEdit from "../views/health-recommendation/HealthRecommendationEdit";

import HealthSlipLiff from "../views/HealthSlipLiff";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Landing,
  },
  {
    path: "/register",
    name: "register",
    component: UserRegister,
  },
  {
    path: "/callback",
    name: "callback",
    component: CmuItAccountCallback,
  },
  {
    path: "/health-recommendation/:healthRecommendationId",
    name: "health-recommendation-view",
    component: HealthRecommendationView,
  },
  {
    path: "/assessment-history",
    name: "assessment-history",
    component: UserLayout,
    redirect: {
      path: "/assessment-history/risk",
    },
    children: [
      {
        path: "overview",
        name: "assessment-history.overview",
        component: UserOverviewDashboard,
      },
      {
        path: "risk",
        name: "assessment-history.risk",
        component: UserRiskDashboard,
      },
      {
        path: "whoqol",
        name: "assessment-history.whoqol",
        component: UserWhoQolDashboard,
      },
      {
        path: "hplp",
        name: "assessment-history.hplp",
        component: UserHPLPDashboard,
      },
    ],
  },
  {
    path: "",
    name: "User",
    component: UserLayout,
    children: [
      {
        path: "health-slip-liff",
        name: "health-slip-liff",
        component: HealthSlipLiff,
      },
      {
        path: "/assessments",
        name: "assessments",
        component: AssessmentMenu,
      },
      {
        path: "/assessment-whoqol",
        name: "assessment-whoqol",
        component: AssessmentWhoqolBref,
      },
      {
        path: "/assessment-whoqol/:id",
        name: "assessment-whoqol.result",
        component: WhoqolAssessmentResult,
      },
      {
        path: "/assessment-hplp",
        name: "assessment-hplp",
        component: AssessmentHPLP,
      },
      {
        path: "/assessment-hplp/:id",
        name: "assessment-hplp.result",
        component: AssessmentHPLPResult,
      },
      {
        path: "/survey",
        name: "assessment-risk",
        component: Survey,
      },
      {
        path: "/risk-assessment/:id",
        name: "RiskAssessmentResult",
        component: RiskAssessmentResult,
      },
      {
        path: "/manual/assessment",
        name: "manual.assessment",
        component: ManualAssessment,
      },
      {
        path: "/manual/report",
        name: "manual.report",
        component: ManualReport,
      },
    ],
  },
  {
    path: "/admin",
    name: "admin",
    redirect: {
      path: "/admin/dashboard/risk/overview",
    },
  },
  {
    path: "/admin/dashboard",
    name: "AdminDashboard",
    component: AdminDashboard,
    redirect: {
      path: "/admin/dashboard/risk/overview",
    },
    children: [
      {
        path: "sms/sender",
        component: AdminSmsSender,
        name: "sms.sender",
      },
      {
        path: "risk",
        component: RiskDashboard,
        name: "",
      },
      {
        path: "risk/topic",
        component: RiskTopicDashboard,
        name: "RiskTopicDashboard",
      },
      {
        path: "risk/overview",
        component: RiskDashboardOverview,
      },
      {
        path: "risk/faculty",
        name: "RiskDashboardFaculty",
        component: RiskDashboardFaculty,
      },
      {
        path: "risk/employee",
        name: "RiskDashboardEmployee",
        component: RiskDashboardEmployee,
      },
      {
        path: "whoqol/overview",
        name: "WhoqolDashboardOverview",
        component: WhoqolDashboardOverview,
      },
      {
        name: "WhoqolDashboardCategory",
        path: "whoqol/category",
        component: WhoqolDashboardCategory,
      },
      {
        path: "whoqol/group",
        name: "WhoqolDashboardGroup",
        component: WhoqolDashboardGroup,
      },
      {
        path: "whoqol/faculty",
        name: "WhoqolDashboardFaculty",
        component: WhoqolDashboardFaculty,
      },
      {
        path: "hplp/overview",
        name: "HPLPDashboardOverview",
        component: HPLPDashboardOverview,
      },
      {
        path: "hplp/category",
        name: "HPLPDashboardCategory",
        component: HPLPDashboardCategory,
      },
      {
        path: "hplp/group",
        name: "HPLPDashboardGroup",
        component: HPLPDashboardGroup,
      },
      {
        path: "hplp/faculty",
        name: "HPLPDashboardFaculty",
        component: HPLPDashboardFaculty,
      },
      {
        path: "admin/manage",
        name: "AdminManagement",
        component: AdminManagement,
      },
      {
        path: "faculty/admin/:facultyId",
        name: "FacultyAdminManagement",
        component: FacultyAdminManagement,
      },
      {
        path: "assessment/compare",
        name: "AdminAssessmentCompare",
        component: AdminAssessmentCompare,
      },

      {
        path: "health-recommendation",
        name: "admin-health-recommendation-index",
        component: HealthRecommendationIndex,
      },
      {
        path: "health-recommendation/create",
        name: "admin-health-recommendation-create",
        component: HealthRecommendationCreate,
      },
      {
        path: "health-recommendation/edit/:healthRecommendationId",
        name: "admin-health-recommendation-edit",
        component: HealthRecommendationEdit,
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   console.log(from);
//   console.log(to);

//   next();
// });

export default router;
